<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词" clearable></el-input>
                </el-form-item>
                <el-form-item label="消费类型">
                    <el-select v-model="form.type" clearable placeholder="消费类型">
                        <el-option label="充值" :value="1"></el-option>
                        <el-option label="消费" :value="2"></el-option>
                        <el-option label="卡劵消费" :value="3"></el-option>
                        <el-option label="卡劵释放" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="充值时间">
                    <el-date-picker
                        v-model="form.datesVelue"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <!--<el-table-column
                    min-width="120"
                    prop="studentName"
                    label="学生" >
                </el-table-column>-->
                <el-table-column
                    min-width="120"
                    label="类型" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" v-if="scope.row.type == 2">
                              {{scope.row.typeName}}（{{scope.row.studentName}}）
                        </div>
                        <div class="fx-col fx-center" v-if="scope.row.type == 3 || scope.row.type == 4">
                              {{scope.row.typeName}}（{{scope.row.cardCouponSn}}）
                        </div>
                        <div class="fx-col fx-center" v-if="scope.row.type == 1">
                              {{scope.row.typeName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="beforeChargeCount"
                    label="操作前天数" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop=""
                    label="操作天数" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#69e93f" v-if="scope.row.type == 1  || scope.row.type == 4">
                              {{scope.row.chargeCount}}
                        </div>
                        <div class="fx-col fx-center" style="color:#F56C6C" v-if="scope.row.type == 2 || scope.row.type == 3">
                              -{{scope.row.chargeCount}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="afterChargeCount"
                    label="操作后天数" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="userName"
                    label="操作人" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="createTime"
                    label="充值时间" >
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>
    .class_title {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;

    }
    .class_title i.iconfont {
        font-size: 20px;
        color: var(--primary);
    }
    .remove_btn {
        margin-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>


<script>


    export default {
        components: {
        },

        data() {
            return {
                form: {
                    classId: "",
                    type: "",
                    enable: false,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                schoolOptin:{},
                tableData: [],
            }
        },
        watch: {
            "form": {
				handler: function (newValue) {
					this.pager.currentPage = 1;
					this.loadData();
				},
				deep: true
			}
        },

        methods: {
            loadData() {
                    this.form.startTime = this.form.datesVelue != null ? this.form.datesVelue[0] : "";
                    this.form.endTime = this.form.datesVelue != null ? this.form.datesVelue[1] : "";
                this.$ajaxPost("/institutionChargeLog/list", {
                    form:this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            // loadSchoolOptin() {
            //     this.$ajaxGet("/institution/getInstitutionList", (data) => {
            //         this.schoolOptin = data.result;
            //     })
            // },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
        },

        created() {
            this.loadData();
            // this.loadSchoolOptin();
        }

    }
</script>
